import { useCallback, useEffect, useMemo, useState } from "react";
import { scopeOptions } from "../utils/constants";

export const useFilterScopes = (activeCase) => {
  const [filterScopes, setFilterScopes] = useState(activeCase?.filterScopes || ["doc", "anno"]);

  useEffect(() => {
    setFilterScopes(activeCase?.filterScopes || ["doc", "anno"]);
  }, [activeCase]);

  const scopeOptionList = useMemo(
    () => scopeOptions.map((option) => ({ value: option.value, display: option.label })),
    []
  );

  const scopeLookup = useMemo(() => {
    const map = {};
    scopeOptionList.forEach((option) => {
      map[option.value] = option;
    });
    return map;
  }, [scopeOptionList]);

  const selectedScopeOptions = useMemo(
    () =>
      filterScopes
        .map((value) => scopeLookup[value])
        .filter((option) => Boolean(option)),
    [filterScopes, scopeLookup]
  );

  const handleScopeToggle = useCallback((isSelected, option) => {
    setFilterScopes((prev) => {
      if (isSelected) {
        return prev.filter((value) => value !== option.value);
      }
      return [...prev, option.value];
    });
  }, []);

  return {
    filterScopes,
    scopeOptionList,
    selectedScopeOptions,
    handleScopeToggle,
  };
};


